// removed by extract-text-webpack-plugin
module.exports = {"Blog":"NewChapter__Blog__1gXMI","textArea":"NewChapter__textArea__38Lm7","editordiv":"NewChapter__editordiv__I7g1x","br_for_mobile":"NewChapter__br_for_mobile__15jHZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewChapter/NewChapter.css
// module id = 478
// module chunks = 3